ViewContent - Final 


<template>
  <div class="global_view_content" :key="currentLesson">  
    <!-- <Loader :is-active="hasReady"></Loader> -->
    <div class="content">
      <div class="infoCenter px-1 pt-6 pb-4 d-md-none">
                    {{ currentLesson?.title || '' }}
                    </div>
      <!-- Padrão de frame responsivo para vídeos -->
      <div class="video youtube" v-show="typeLessonPortal === 2">
        <div class="video-frame">
          <iframe
            :key="videoLink"
            :src="`https://www.youtube.com/embed/${videoLink}`"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen>
          </iframe>
        </div>
      </div>
      
      <div class="video vimeo" v-show="typeLessonPortal === 3">
        <div class="video-frame">
          <iframe
            :key="videoLink"
            :src="`https://player.vimeo.com/video/${videoLink}`"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
      </div>

      <div class="quiz" v-if="typeLessonPortal === 5" :key="typeLessonPortal">
        <div class="result" v-show="hasReadyQuizScore">
          <div class="info_percentage">
            <p>Sua nota</p>
            <h3 v-if="hasReadyQuizScore">{{ scoreData.grade ? Math.round(scoreData.grade / 10) : 0 }}</h3>
            <h3 v-else>{{ returnAnswer ? Math.round(returnAnswer.grade / 10) : 0 }}</h3>
          </div>
          <div class="indo_hits">
            <p>Acertos</p>
            <h3 v-if="hasReadyQuizScore"><i class="pi pi-check"></i>{{ scoreData.acertos }}</h3>
            <h3 v-else><i class="pi pi-check"></i>{{ returnAnswer ? returnAnswer.acertos : 0 }}</h3>
          </div>
          <div class="indo_errors">
            <p>Erros</p>
            <h3 v-if="hasReadyQuizScore"><i class="pi pi-times"></i>{{ scoreData.erros }}</h3>
            <h3 v-else><i class="pi pi-times"></i>{{ returnAnswer ? returnAnswer.erros : 0 }}</h3>
          </div>
        </div>

        <div class="quiz-content">
          <Question
            :review="review"
            :dataQuiz="dataQuiz"
            :userAmswer="userAmswer"
            @quiz-submitted="handleQuizSubmitted"
          >
          </Question>
        </div>
      </div>

      <!-- Solução para PDF no mobile: usar iframe ao invés de embed, pois muitos navegadores mobile não suportam embed para PDF -->
      <div class="pdf" v-show="typeLessonPortal === 4" :key="typeLessonPortal">
        <template v-if="pdfSource">
          <iframe
            v-if="isMobile"
            :src="`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(pdfSource)}`"
            style="width: 100%; height: 100vh;"
            frameborder="0"
            allowfullscreen
          ></iframe>
          <embed
            v-else
            style="width: 100%; height: 100vh"
            :src="pdfSource"
          />
        </template>
      </div>

      <div class="videoteca" v-show="typeLessonPortal === 1" :key="typeLessonPortal">
        <div class="video-frame">
          <iframe 
            :src="videoPlayer"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen>
          </iframe>
        </div>
      </div>
      <!-- <div class="titleMobileContent">
        <fa icon="fa-chalkboard-user"/>
        <p>Aula atual: {{ nameCurrentLesson }}</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import PDFViewer from 'pdf-viewer-vue';
import Question from './utils/questions.vue';
import Loader from '@/components/Loader/loader.vue';
import api from '@/utils/portal/lesson.js';
import apiQuiz from '@/utils/portal/quiz';
import playerVideo from '@/utils/storage/playerVideo';

import { mapState, mapActions } from 'vuex';

export default {
  components: {
    PDFViewer,
    Question,
    Loader
  },
  data() {
    return {
      data: [],
      dataQuiz: [],
      pdfSource: null,
      answers: [],
      review: false,
      hasReadyQuiz: false,
      hasReadyQuizScore: false,
      correctAnswerIndices: [],
      idQuiz: null,
      scoreData: [
        {
          acertos: 0,
          erros: 0,
        }
      ],
      videoLink: null,
      typeVideo: null,
      hasReady: false,
      heightPlayer: 500,
      videoPlayer: null,
      isMobile: false,
      returnAnswer: null,
      userAmswer: [],
    };
  },
  computed: {
    ...mapState(['token', 'currentModuleOpen', 'idLessonPortal', 'nameCurrentLesson', 'typeLessonPortal', 'currentLesson', 'currentCoursePortal']),
  },
  methods: {
    ...mapActions(['storePorcetageProgressCurrentCourse']),
    async getPlayerVideo(){
      const id = this.currentLesson.id;
      try {
        const response = await playerVideo.getPlayerVideo(this.token,id);
        this.videoPlayer = response;
        setTimeout(() => {
          this.hasReady = true;
        }, 2000);
      } catch (error) {
        console.error('Erro ao obter o player:', error);
      }
    },
    async getDataQuiz(idQuiz) {
      try {
        const response = await apiQuiz.getDataQuizQuestion(this.token, idQuiz);
        console.debug('dataQuiz', response);
        this.dataQuiz = response;
      } catch (error) {
        console.error('Erro ao carregar o quiz:', error);
      }
    },
    async getDataLesson() {
      try {
        const response = await api.getDataLesson(this.token, this.currentCoursePortal.course.id, this.idLessonPortal);
        if(response.progressCourse != null){
          this.storePorcetageProgressCurrentCourse({ porcetageProgressCurrentCourse: response.progressCourse});
        }
        this.data = response;

        switch (response.type) {
          case 4:
            this.pdfSource = response.finalPath;
            this.hasReady = true;
            break;
          case 5:
            if (response.idQuiz) {
              this.idQuiz = response.idQuiz;
              this.hasReadyQuizScore = response.listUserAnswer && response.listUserAnswer.length > 0;
              this.answersQuiz = response.listUserAnswer || [];
              // Salva as respostas do usuário para o de-para
              this.userAnswersRaw = response.listUserAnswer || [];
              this.getDataQuiz(response.idQuiz);
              this.userAmswer = response.listUserAnswer;
              if(this.userAmswer.length > 0){
                this.review = true;
              }
              if(this.hasReadyQuizScore){
                const corretos = response.listUserAnswer.filter(item => item.correct === 1).length;
                const incorretos = response.listUserAnswer.filter(item => item.correct === 0).length;
                const nota = (corretos / (corretos + incorretos)) * 100;
                this.scoreData = {
                  acertos: corretos,
                  erros: incorretos,
                  grade: nota,
                };
              }
            }
            break;
          case 2:
            this.typeVideo = 'youtube';
            this.videoLink = this.getEmbeddedLink(response.path);
            this.hasReady = true;
            break;
          case 3:
            this.typeVideo = 'vimeo';
            this.videoLink = this.getVimeoVideoId(response.path);
            this.hasReady = true;
            break;
          case 1:
            this.getPlayerVideo();
            break;
          default:
            console.warn('Tipo de lição desconhecido:', response.type);
        }
      } catch (error) {
        console.error('Erro ao carregar a lesson:', error);
      }
    },
    storeAnswer(answer, questionIndex) {
      this.answers[questionIndex] = answer;
    },
    getEmbeddedLink(link) {
      if (link.includes('youtu.be')) {
        return link.split('/').pop().split('?')[0];
      } else if (link.includes('youtube.com/watch')) {
        const params = new URLSearchParams(new URL(link).search);
        return params.get('v');
      } else if (link.includes('youtube.com/embed/')) {
        return link.split('/embed/')[1].split('?')[0];
      } else {
        alert('Por favor, insira um link válido do YouTube.');
        return null;
      }
    },
    getVimeoVideoId(link) {
      console.log(link);
      const videoIdMatch = link.match(/vimeo\.com\/(\d+)/);
      console.log(videoIdMatch);
      return videoIdMatch ? videoIdMatch[1] : null;
    },
    detectMobile() {
      // Detecta se é mobile (simples, pode ser melhorado)
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    async handleQuizSubmitted() {
      // Atualiza os dados da lição após o quiz ser submetido
      await this.getDataLesson();
      // Reset review após submissão do quiz
      console.debug('Quiz submetido, resetando review');
      this.review = false;
    }
  },
  created() {
    this.detectMobile();
    this.getDataLesson();
  },
  watch: {
    idLessonPortal(newValue) {
      this.hasReady = false;
      this.review = false;
      this.getDataLesson();
    },
    typeLessonPortal(newValue) {
      this.videoLink = null;
      this.typeVideo = null;
    },
    currentCoursePortal(newValue, oldValue) {
      // Reset review quando mudar de curso
      if (oldValue && newValue && oldValue.course?.id !== newValue.course?.id) {
        console.debug('Mudança de curso detectada, resetando review:', {
          cursoAnterior: oldValue.course?.id,
          novoCurso: newValue.course?.id
        });
        this.review = false;
        this.hasReady = false;
        this.hasReadyQuizScore = false;
        this.userAmswer = [];
        this.dataQuiz = [];
        this.scoreData = [{
          acertos: 0,
          erros: 0,
        }];
      }
    },
  },
};
</script>

<style scoped>
.global_content_course.dark .titleMobileContent {
  background-color: gray;
  color: white;
}
.global_content_course.dark .titleMobile {
  color: white;
}
.titleMobileContent{
  gap: 10px;
  padding: 10px;
  /* text-decoration: underline; */
  margin: 0px;
  display: flex;
  background-color: white;
  align-items: center;
}
.titleMobileContent p {
  margin: 0 !important;
}
.global_view_content {
  min-height: 89vh;
  overflow-y: auto;
  position: relative;
  padding: 10px;
  margin: 17px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0px 0px 10px 1px #f1f1f1;
}
.dark .global_view_content {
  min-height: 89vh;
  overflow-y: auto;
  position: relative;
  padding: 10px;
  margin: 17px;
  background-color: #181a20 !important;
  border-radius: 6px;
  box-shadow: 0px 0px 10px 1px #181a20;
}
button.end_quiz {
  background: #3b2d70;
  padding: 5px 40px;
  color: white;
  border-radius: 5px;
}
.result {
  background-color: white;
  border-radius: 10px;
  width: 600px;
  margin: 15px auto;
  display: flex;
  padding: 20px;
  gap: 50px;
}
.dark .result {
  background-color: #181a20;;
}
.info_percentage {
  width: 300px;
  background-color: #f4fcfc;
  padding: 10px;
  border-radius: 10px;
}
.info_percentage h3 {
  font-weight: 800;
}
.indo_hits {
  width: 150px;
  background-color: #f1fce3;
  padding: 10px;
  color: #84ba41;
  border-radius: 10px;
}
.indo_hits h3 {
  color: black;
  font-weight: 800;
}
.indo_errors {
  width: 150px;
  background-color: #fcdfdf;
  padding: 10px;
  color: red;
  border-radius: 10px;
}
.indo_errors h3 {
  color: black;
  font-weight: 800;
}
.result i {
  font-size: 20px;
  margin-right: 5px;
}
.indo_errors i {
  color: red;
}
.indo_hits i {
  color: green;
}
.quiz {
  position: relative;
  min-height: 92vh;
}
.option_question_quiz p {
  margin: 0;
}
.content .video {
  height: 600px;
}
/* Frame responsivo para vídeos */
.video-frame {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
  background: #000;
}
.video-frame iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* Remove estilos antigos de altura fixa dos iframes de vídeo */
.video.youtube iframe,
.video.vimeo iframe {
  height: 600px !important;
  min-height: unset !important;
  max-height: unset !important;
}

/* Ajuste para PDFs */
.pdf embed,
.pdf iframe {
  width: 100%;
  height: 100vh; /* Altura padrão para telas maiores */
  border: none;
}

@media (max-width: 768px) {
  .option_question_quiz {
    display: flex;
    align-items: center;
    padding: 15px 10px;
}
  .result {
    flex-wrap: wrap;
    width: 100%;
    gap: 10px;
}
.info_percentage{
  width: 100%;
}
.indo_hits, .indo_errors{
  width: 48%;
}
  .global_view_content {
    padding: 0px 10px;
  }
  .pdf embed,
  .pdf iframe {
    height: 70vh;
  }
}

@media (max-width: 480px) {
  .pdf embed,
  .pdf iframe {
    height: 50vh;
  }
}
.global_view_content .content {
  border-radius: 5px;
  overflow: hidden;
}
.question-block {
  border: 1px solid #e2e2e2;
  margin: 10px 0px;
  border-radius: 10px;
}
</style>

